/** Marks an element a buddy can run from or to; its value names the home. */
export const BUDDY_HOME_ATTRIBUTE = 'data-buddy-home';

export const BUDDY_TRIP_MS = 1600;
export const BUDDY_TRIP_SIZE = 56;
export const BUDDY_TRIP_ARC_PX = 90;
